import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/broadcasts` URL, which lands on a tab. Flag off the embedded app serves it; flag on it forwards to the migrated list. The
 * resolver belongs here: this URL keeps the `journeys` segment, so a `/workspaces/last`
 * sentinel has to resolve before the embedded app mounts on it.
 */
function JourneysBroadcastsIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsHandoff tab={null} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/')({
  component: JourneysBroadcastsIndexRoute,
});
